export type StaffMember = {
    name: string
    gif: string
    tag: string
    channelURL?: string
}

const STAFF: StaffMember[] = [
    { name: 'Alex Hoang', gif: 'https://media.giphy.com/staff/alex-hoang-96MS1JWoHnqg.gif', tag: 'flex' },
    { name: 'Alex Li', gif: 'https://media.giphy.com/staff/alex-li-PYSMaGTuy7TD.gif', tag: 'loop' },
    { name: 'Alix McAlpine', gif: 'https://media.giphy.com/staff/alix-mcalpine-jthF44RgefSS.gif', tag: 'awooga' },
    {
        name: 'Arielle Martorana',
        gif: 'https://media.giphy.com/staff/arielle-martorana-dIKhja7TfsXT.gif',
        tag: 'hashbrown',
    },

    { name: 'Becky Dole', gif: 'https://media.giphy.com/staff/becky-dole-V7GDHshln0zH.gif', tag: 'oy vey' },
    { name: 'Ben Loescher', gif: 'https://media.giphy.com/staff/ben-loescher-wySKvZC4Hso2.gif', tag: 'happyhour' },
    { name: 'Chris Cimino', gif: 'https://media.giphy.com/staff/chris-cimino-nlAInHjRROdj.gif', tag: 'gritty' },
    {
        name: 'Chris Vavra',
        gif: 'https://media.giphy.com/staff/chris-vavra-006uq3AJejQl.gif',
        tag: 'shrimp',
        channelURL: 'https://giphy.com/vavra',
    },

    { name: 'Dan Burke', gif: 'https://media.giphy.com/staff/dan-burke-P9S8EOa0xoNI.gif', tag: 'birdman' },
    { name: 'Danny Chang', gif: 'https://media.giphy.com/staff/danny-chang-bjTGkNCLouCm.gif', tag: 'happybara' },
    { name: 'Eric Goldfarb', gif: 'https://media.giphy.com/staff/eric-goldfarb-j7eAfBAduaUa.gif', tag: 'magic man' },
    { name: 'Erica Seamster', gif: 'https://media.giphy.com/staff/erica-seamster-iSwgINd5kYxB.gif', tag: 'pizza' },

    { name: 'Gianni Ferullo', gif: 'https://media.giphy.com/staff/gianni-ferullo-41fXLbDl7ZfC.gif', tag: 'shaka' },
    { name: 'Hope Sincere', gif: 'https://media.giphy.com/staff/hope-sincere-1CZoNzQglPhw.gif', tag: 'hug' },
    { name: 'Jake Walker', gif: 'https://media.giphy.com/staff/jake-walker-aWDuVwt5pXqD.gif', tag: 'kpop' },
    { name: 'Jason Clarke', gif: 'https://media.giphy.com/staff/jason-clarke-DdksBUKQU5Il.gif', tag: 'loop' },

    { name: 'Jason Stein', gif: 'https://media.giphy.com/staff/jason-stein-D4SEwR5nPCpc.gif', tag: 'loop' },
    { name: 'Julia Schulman', gif: 'https://media.giphy.com/staff/julia-schulman-AZWwtURRNmOB.gif', tag: 'loop' },
    {
        name: 'Kyle Carlson',
        gif: 'https://media.giphy.com/staff/kyle-carlson-p0Xjmlu472Zt.gif',
        tag: 'rhett hammersmith',
    },
    {
        name: 'Marc Leone',
        gif: 'https://media.giphy.com/staff/marc-leone-JG4mLNpRPtph.gif',
        tag: 'bat flip',
        channelURL: 'https://giphy.com/mdleone',
    },

    { name: 'Meg Lewis', gif: 'https://media.giphy.com/staff/meg-lewis-83vksON1DL4S.gif', tag: 'the rock' },
    { name: 'Mike Bruno', gif: 'https://media.giphy.com/staff/mike-bruno-8TJYfehvrdMY.gif', tag: 'nyc' },
    {
        name: 'Nick Santaniello',
        gif: 'https://media.giphy.com/staff/nick-santaniello-beUCT46dPK2p.gif',
        tag: 'floppy disk',
        channelURL: 'https://giphy.com/channel/chubbrck',
    },

    {
        name: 'Nikki Vinayan',
        gif: 'https://media.giphy.com/staff/nikki-vinayan-8QAEKUZ2rgI8.gif',
        tag: 'eye roll',
        channelURL: 'https://giphy.com/Nikki-Vinayan',
    },
    { name: 'Pankaj Khatkar', gif: 'https://media.giphy.com/staff/pankaj-khatkar-7NTyCzDcxrVg.gif', tag: 'nebulla' },
    { name: 'Priya Shah', gif: 'https://media.giphy.com/staff/priya-shah-gv0K2CpiMAIY.gif', tag: 'lol' },
    { name: 'Ralph Bishop', gif: 'https://media.giphy.com/staff/ralph-bishop.gif', tag: 'awesome' },

    { name: 'Raymond Wong', gif: 'https://media.giphy.com/staff/raymond-wong.gif', tag: 'hello' },
    { name: 'Sabrina Pacheco', gif: 'https://media.giphy.com/staff/sabrina-pacheco-xmnfEuvAx5jI.gif', tag: 'gracias' },
    { name: 'Samantha Albert', gif: 'https://media.giphy.com/staff/samantha-albert-CAEBnTVF7mSs.gif', tag: 'shade' },
    {
        name: 'Stacy Rizzetta',
        gif: 'https://media.giphy.com/staff/stacy-rizzeta-I9AmkyHdJohA.gif',
        tag: 'gosling cereal',
    },

    { name: 'Stephanie Weber', gif: 'https://media.giphy.com/staff/stephanie-weber-xRPMt2jp5JAy.gif', tag: 'vintage' },
    { name: 'Tomas Ferraro', gif: 'https://media.giphy.com/staff/tomas-ferraro-Z0Zvtzv98YWL.gif', tag: 'dunk' },
    { name: 'Tyler Menzel', gif: 'https://media.giphy.com/staff/tyler-menzel.gif', tag: 'swag' },
    {
        name: 'Zack Kantor',
        gif: 'https://media.giphy.com/staff/zack-kantor-Mjz4FdhEsq9k.gif',
        tag: 'vibe',
        channelURL: 'http://www.giphy.com/zck_kntr',
    },
]

export default STAFF
